export const getDateFiltersForQueries = (dates: (Date | null)[] | null) => {
  const startDateAndTime = dates && dates[0] ? new Date(dates[0]) : null;
  let endDateAndTime = dates && dates[1] ? new Date(dates[1]) : null;

  if (startDateAndTime && !endDateAndTime) {
    endDateAndTime = new Date(startDateAndTime);
    endDateAndTime.setHours(23);
    endDateAndTime.setMinutes(59);
  } else if (startDateAndTime && endDateAndTime) {
    endDateAndTime.setHours(23);
    endDateAndTime.setMinutes(59);
  }
  return { startDateAndTime, endDateAndTime };
};
